import { useQuery } from '@tanstack/react-query'
import { getTemplates } from '../api/endpoints'

export const useTemplates = () => {
  return useQuery({
    queryKey: ['subscription', 'templates'],
    queryFn: () => getTemplates(),
  })
}
